module.exports = __webpack_public_path__ + "img/tron (62).9dfeb0d8.jpg";